import { useEffect, useRef } from "react";
import { indicatorLog } from "../../functions/helper/helpers.functions.js";
import { pageNames } from "../../reduxStore/reducers/main.js";
import {
  autoReset,
  terminalIdleTime,
  terminalStandardLanguage,
} from "./useURLParams.sideEffects.js";

/**
 * Setzt einen Timer, der nach jeder Berührung mit der App wieder zurückgesetzt wird. Sollte er einmal ablaufen, so
 * geht er zurück in seinen Urzustand: Also auf die Page MapInfo, ohne etwas ausgewählt zu haben.
 * @param {boolean} isTerminal
 * @param {boolean} terminalIsIdle - Gibt den Zustand des Idle Modus an
 * @param {function} setTerminalIsIdle
 * @param history
 * @param introComplete
 * @param setCurrentAppOverlay
 */
export default function useTerminalIdleMode(
  isTerminal,
  terminalIsIdle,
  setTerminalIsIdle,
  history,
  introComplete,
  setCurrentAppOverlay,
  setCurrentFeature,
  setLanguage
) {
  // --- refs ----
  const idleTimeout = useRef();
  const idleTimeout_time = terminalIdleTime * 1000;

  // --- functions ---
  const setTerminalTimeout = () => {
    setTerminalIsIdle(false);
    if (autoReset === "false") return;
    // Timeout beginnt
    clearTimeout(idleTimeout.current);
    idleTimeout.current = setTimeout(
      () => setTerminalIsIdle(true),
      idleTimeout_time
    );
  };
  const manageListeners = () => {
    if (!isTerminal || !introComplete) return;

    indicatorLog("Verwendung als Terminal", { background: "black" });

    // globale listener definieren, welche bei betätigung das timeout resetten
    window.addEventListener("mousedown", setTerminalTimeout);
    window.addEventListener("wheel", setTerminalTimeout);
    window.addEventListener("touchdown", setTerminalTimeout);
    window.addEventListener("touchmove", setTerminalTimeout);

    setTerminalTimeout();

    return () => {
      window.removeEventListener("mousedown", setTerminalTimeout);
      window.removeEventListener("wheel", setTerminalTimeout);
      window.removeEventListener("touchdown", setTerminalTimeout);
      window.removeEventListener("touchmove", setTerminalTimeout);

      clearTimeout(idleTimeout.current);
    };
  };
  const handleTerminalChanges = () => {
    if (!isTerminal || !introComplete) return;

    if (terminalIsIdle) {
      indicatorLog("Terminal ist im Idlezustand", { background: "blue" });
      history.push(
        `/${pageNames.map}/${pageNames.info}${window.location.search}`
      );
      setCurrentFeature();
      setCurrentAppOverlay();
      console.log("setterminal idle language", terminalStandardLanguage);
      setLanguage(terminalStandardLanguage);
    } else {
      indicatorLog("Terminal ist im Benutzungszustand", { background: "blue" });
    }
  };

  // --- effects ---
  useEffect(manageListeners, [isTerminal, introComplete]);
  useEffect(handleTerminalChanges, [terminalIsIdle, introComplete]);
}
